"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            history: [],
            subscribe: false,
            duration: 1,
            alert: false
        };
        GState.bind(this, [
            'user',
            'tenant',
            'paystackDefaultCreds'
        ]);
    },
    onMount: async function () {
        this.fetchHistory();
        await import('~/../public/vendors/paystack.inline.min');
    },
    onSubscribe: function (dataset) {
        this.state.subscribe = dataset;
    },
    onDurationSet: function (e) {
        this.state.duration = Number(e.target.value);
    },
    onContinue: function () {
        const {type, price, per} = this.state.subscribe, amount = Number(price * this.state.duration), currency = 'GHS';
        window.PaystackPop.setup({
            key: this.state.paystackDefaultCreds.accessKey,
            email: this.state.user.email,
            amount: amount * 100,
            currency,
            ref: String(Math.floor(Math.random() * 1000000000 + 1)),
            label: type + ' package',
            callback: response => {
                const {message, reference, transaction} = response;
                if (message != 'Approved') {
                    console.log('Payment Not Approved: ', response);
                    return;
                }
                uiStore.set('subscribe-payment', {
                    amount,
                    reference,
                    transaction
                });
                this.onSubmit({
                    type,
                    per,
                    duration: this.state.duration,
                    payment: {
                        amount,
                        currency,
                        reference,
                        transaction
                    }
                });
            }
        }).openIframe();
    },
    fetchHistory: async function () {
        try {
            const {error, message, results, more} = await Request(`/subscription/tenant/${ this.state.more || '/history' }`);
            if (error)
                return console.log('Error Fetching Subscription History: ', message);
            if (more) {
                this.state.more = more;
                this.state.history = [
                    ...this.state.history,
                    ...results
                ];
            }
            this.state.history = results.map(({type, status, duration, payment, added}) => {
                return {
                    type,
                    status,
                    price: payment ? payment.currency + payment.amount : '-',
                    start: formatDate(duration.start, 'calendar'),
                    end: formatDate(duration.end, 'calendar'),
                    by: added.by
                };
            });
        } catch (error) {
            console.log('Error Fetching Histories: ', error);
        }
    },
    onSubmit: async function (payload) {
        try {
            const {error, message, reference} = await Request('/subscription/tenant/add', 'POST', payload);
            if (error)
                throw new Error(message);
            console.log('Subscription submitted: ', reference);
            GState.tenant.refresh();
            uiStore.clear('subscribe-payment');
            this.state.alert = { message };
            setTimeout(() => this.onSubscribe(false), 8000);
        } catch (error) {
            console.log('Submiting subscription Failed: ', error);
            this.state.alert = {
                type: 'warning',
                message: error.message
            };
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/BillPayment/Admin/Subscription.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    SubscriptionTable_template = require("../../../components/SubscriptionTable/index.marko"),
    SubscriptionTable_tag = marko_loadTag(SubscriptionTable_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Datatable_template = require("../../../components/Datatable/index.marko"),
    Datatable_tag = marko_loadTag(Datatable_template),
    Price_template = require("../../../../components/Price/index.marko"),
    Price_tag = marko_loadTag(Price_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    FormAlert_template = require("../../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "px-1"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("01a0a9"),
    marko_node0 = marko_createElement("br", null, "11", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "mt-0"
      },
    marko_node2 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "17", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "position-absolute zindex-2 w-100 h-100 top-0 left-0 d-flex align-items-center center"
      },
    marko_attrs3 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_node7 = marko_createElement("br", null, "27", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "px-50"
      },
    marko_node8 = marko_createElement("br", null, "35", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "form-group"
      },
    marko_node9 = marko_createElement("br", null, "39", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node10 = marko_createElement("br", null, "41", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "btn btn-secondary btn-lg m-25"
      },
    marko_attrs7 = {
        "class": "btn btn-primary btn-lg m-25"
      };

const tableFormat = [
	{ key: 'trindex', label: '#', col: '1' },
	{ key: 'type', label: 'Package' },
	{ key: 'status', label: 'Status', style: 'text-success' },
	{ key: 'price', label: 'Price' },
	{ key: 'start', label: 'Start Date' },
	{ key: 'end', label: 'End Date' },
	{ key: 'by', label: 'By' }
];

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        if ((state.tenant && state.tenant.subscription) && state.tenant.subscription.type) {
          out.be("div", null, "2", component);

          const { type, duration } = state.tenant.subscription

          Locale_tag({
              text: "Current",
              class: "text-muted font-small-3"
            }, out, __component, "3");

          out.be("h5", marko_attrs1, "4", component);

          Locale_tag({
              text: type.toCapitalCase() + " package"
            }, out, __component, "5");

          out.ee();

          Locale_tag({
              text: "From",
              class: "text-primary"
            }, out, __component, "6");

          out.t(" ");

          out.t(formatDate(duration.start, "calendar"), component);

          out.t(" ");

          Locale_tag({
              text: "To",
              class: "text-primary"
            }, out, __component, "7");

          out.t(" ");

          out.t(formatDate(duration.end, "calendar"), component);

          out.ee();

          out.n(marko_node2, component);

          out.n(marko_node3, component);
        }

        Locale_tag({
            text: "Packages",
            class: "text-muted font-small-3"
          }, out, __component, "10");

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        SubscriptionTable_tag({}, out, __component, "13", [
          [
            "subscribe",
            "onSubscribe",
            false
          ]
        ]);

        if (Array.isArray(state.history) && state.history.length) {
          out.be("div", null, "14", component);

          out.n(marko_node4, component);

          out.n(marko_node5, component);

          out.n(marko_node6, component);

          Row_tag({
              class: "d-flex align-items-center",
              col: [
                  {
                      renderBody: function(out) {
                        Locale_tag({
                            text: "History",
                            class: "text-muted font-small-3"
                          }, out, __component, "20");
                      }
                    },
                  {
                      ns: "col-5",
                      qs: "col-7",
                      hs: "col-7"
                    }
                ]
            }, out, __component, "18");

          Datatable_tag({
              format: tableFormat,
              data: state.history,
              pagination: 10,
              stripped: true,
              class: "w-100"
            }, out, __component, "22", [
            [
              "canload",
              "fetchHistory",
              false
            ]
          ]);

          out.ee();
        }

        if (state.subscribe) {
          const { type, price, per } = state.subscribe

          out.be("div", marko_attrs2, "23", component);

          Row_tag({
              class: "m-0 w-100 d-flex justify-content-center",
              renderBody: function(out) {
                out.e("div", marko_attrs3, "25", component, 0, 0, {
                    onclick: __component.d("click", "onSubscribe", false, [
                        false
                      ])
                  });

                WSAdapt_tag({
                    ns: "col-4",
                    qs: "col-6",
                    hs: "col-7",
                    class: "animated zoomIn faster",
                    style: "padding-bottom:150px",
                    renderBody: function(out) {
                      out.n(marko_node7, component);

                      Locale_tag({
                          text: "Subscription",
                          class: "font-small-3 text-muted"
                        }, out, __component, "28");

                      out.be("h4", null, "29", component);

                      Locale_tag({
                          text: type.toCapitalCase() + " package"
                        }, out, __component, "30");

                      out.ee();

                      out.be("p", null, "31", component);

                      Price_tag({
                          amount: price,
                          currency: "$",
                          class: "font-medium-5 text-success"
                        }, out, __component, "32");

                      out.be("span", marko_attrs4, "33", component);

                      out.t(" ");

                      Locale_tag({
                          text: "per"
                        }, out, __component, "34");

                      out.t(" ");

                      out.t(per, component);

                      out.ee();

                      out.ee();

                      out.n(marko_node8, component);

                      out.be("div", marko_attrs5, "36", component);

                      out.be("label", null, "37", component);

                      Locale_tag({
                          text: "Number of months",
                          class: "text-muted"
                        }, out, __component, "38");

                      out.ee();

                      out.n(marko_node9, component);

                      out.e("input", {
                          type: "number",
                          min: "1",
                          value: state.duration,
                          "class": "form-control form-control-lg px-2"
                        }, "40", component, 0, 0, {
                          oninput: __component.d("input", "onDurationSet", false)
                        });

                      out.ee();

                      out.n(marko_node10, component);

                      Row_tag({
                          class: "d-flex align-items-center",
                          col: [
                              {
                                  class: "col-5",
                                  renderBody: function(out) {
                                    Locale_tag({
                                        text: "Total"
                                      }, out, __component, "44");

                                    out.t(": ");

                                    Price_tag({
                                        amount: price * state.duration,
                                        currency: "$",
                                        class: "font-medium-5 text-success"
                                      }, out, __component, "45");
                                  }
                                },
                              {
                                  class: "col-7 text-right",
                                  renderBody: function(out) {
                                    out.be("button", marko_attrs6, "47", component, null, 0, {
                                        onclick: __component.d("click", "onSubscribe", false, [
                                            false
                                          ])
                                      });

                                    Locale_tag({
                                        text: "Cancel"
                                      }, out, __component, "48");

                                    out.ee();

                                    out.be("button", marko_attrs7, "49", component, null, 0, {
                                        onclick: __component.d("click", "onContinue", false)
                                      });

                                    Locale_tag({
                                        text: "Continue"
                                      }, out, __component, "50");

                                    out.ee();
                                  }
                                }
                            ]
                        }, out, __component, "42");
                    }
                  }, out, __component, "26");

                if (state.alert) {
                  FormAlert_tag({
                      alert: state.alert
                    }, out, __component, "51");
                }
              }
            }, out, __component, "24");

          out.ee();
        }

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
